import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "utils/notifications";
import ConfigPhiKhacApi from "service/QuanTriHeThong/CauHinhTinhLaiVaHeThong/ConfigPhiKhacApi";
import ConfigPhiKhacHangKyApi from "service/QuanTriHeThong/CauHinhTinhLaiVaHeThong/ConfigPhiKhacHangKyApi";

export const ModalXoa = ({ show, onHide, item, onDeleted, isPeriodic }) => {
    const [isSubmit, setIsSubmit] = useState(false);
    useEffect(() => {
        if (show) {
            setIsSubmit(false);
        }
    }, [show]);
    if (!item) return null;
    const api = isPeriodic ? ConfigPhiKhacHangKyApi : ConfigPhiKhacApi;
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setIsSubmit(true);
        try {
            const res = await api.delete(item.ConfigPhiKhacId);
            if (res.status === 200) {
                pushNotification("Xóa thành công!", "success", "TOP_CENTER", 2000);
                onDeleted();
            } else {
                pushNotification(res.data || "Xóa thất bại!", "error", "TOP_CENTER", 2000);
            }
        } catch (err) {
            pushNotification(err?.response?.data || "Xóa thất bại!", "error", "TOP_CENTER", 2000);
        } finally {
            setIsSubmit(false);
            onHide();
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered className="modal-new modal-fade">
            <form onSubmit={handleFormSubmit}>
                <Modal.Header>
                    <h4 className="modal-title color7-bold ml-1">Xác nhận xóa</h4>
                    <button type="button" className="close-popup-new" onClick={onHide}>
                        <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <p style={{ fontSize: '16px', textAlign: 'center'}}>Bạn có chắc chắn muốn xóa phí: <strong>{item.TenPhiKhac}</strong>?</p>
                    <p className="vertical-align-v2" style={{ color: 'rgb(255, 81, 112)', textAlign: 'center' }}>Hành động này không thể hoàn tác.</p>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-new-main btn-closenew" onClick={onHide}>Hủy</button>
                    <button type="submit" className="btn btn-new-main btn-danger" disabled={isSubmit}>
                        {isSubmit ? "Đang xóa..." : "Đồng ý xóa"}
                    </button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};